import { Component } from '@angular/core';

@Component({
    selector: 'app-headerhome',
    templateUrl: './headerhome.component.html',
    styleUrls: ['./headerhome.component.css'],
    standalone: false
})
export class HeaderhomeComponent {}
